import { render } from "./EstimatedCost.vue?vue&type=template&id=71c63b68"
import script from "./EstimatedCost.vue?vue&type=script&lang=js"
export * from "./EstimatedCost.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1559117955/src/employer_portal_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__